import { render, staticRenderFns } from "./ArchiveFooter.vue?vue&type=template&id=0cb3664a&"
import script from "./ArchiveFooter.vue?vue&type=script&lang=js&"
export * from "./ArchiveFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports